import React from "react";
import Countdown from "../../components/sections/Home/Countdown";

export default function Index() {
    return (
        <>
            <Countdown />
        </>
    );
}
